module.exports = __webpack_public_path__ + "static/media/CC20-AP140-12.b04d3a8a.png";